var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGoogle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 24 24"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "google_svg__a",
  d: "M23.182 9.818H12v4.637h6.436c-.6 2.945-3.109 4.636-6.436 4.636A7.077 7.077 0 0 1 4.91 12 7.077 7.077 0 0 1 12 4.91c1.69 0 3.218.6 4.418 1.58L19.91 3C17.782 1.145 15.055 0 12 0 5.345 0 0 5.345 0 12s5.345 12 12 12c6 0 11.455-4.364 11.455-12 0-.71-.11-1.473-.273-2.182"
}), /*#__PURE__*/React.createElement("path", {
  id: "google_svg__c",
  d: "M23.182 9.818H12v4.637h6.436c-.6 2.945-3.109 4.636-6.436 4.636A7.077 7.077 0 0 1 4.91 12 7.077 7.077 0 0 1 12 4.91c1.69 0 3.218.6 4.418 1.58L19.91 3C17.782 1.145 15.055 0 12 0 5.345 0 0 5.345 0 12s5.345 12 12 12c6 0 11.455-4.364 11.455-12 0-.71-.11-1.473-.273-2.182"
}), /*#__PURE__*/React.createElement("path", {
  id: "google_svg__e",
  d: "M23.182 9.818H12v4.637h6.436c-.6 2.945-3.109 4.636-6.436 4.636A7.077 7.077 0 0 1 4.91 12 7.077 7.077 0 0 1 12 4.91c1.69 0 3.218.6 4.418 1.58L19.91 3C17.782 1.145 15.055 0 12 0 5.345 0 0 5.345 0 12s5.345 12 12 12c6 0 11.455-4.364 11.455-12 0-.71-.11-1.473-.273-2.182"
}), /*#__PURE__*/React.createElement("path", {
  id: "google_svg__g",
  d: "M23.182 9.818H12v4.637h6.436c-.6 2.945-3.109 4.636-6.436 4.636A7.077 7.077 0 0 1 4.91 12 7.077 7.077 0 0 1 12 4.91c1.69 0 3.218.6 4.418 1.58L19.91 3C17.782 1.145 15.055 0 12 0 5.345 0 0 5.345 0 12s5.345 12 12 12c6 0 11.455-4.364 11.455-12 0-.71-.11-1.473-.273-2.182"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "google_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#google_svg__a"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FBBC05",
  d: "M-1.09 19.09V4.91L8.181 12z",
  mask: "url(#google_svg__b)"
}), /*#__PURE__*/React.createElement("mask", {
  id: "google_svg__d",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#google_svg__c"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#EA4335",
  d: "M-1.09 4.91 8.181 12 12 8.673l13.09-2.128V-1.09H-1.09z",
  mask: "url(#google_svg__d)"
}), /*#__PURE__*/React.createElement("mask", {
  id: "google_svg__f",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#google_svg__e"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#34A853",
  d: "M-1.09 19.09 15.272 6.546l4.309.546 5.509-8.182v26.182H-1.091z",
  mask: "url(#google_svg__f)"
}), /*#__PURE__*/React.createElement("mask", {
  id: "google_svg__h",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#google_svg__g"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#4285F4",
  d: "M25.09 25.09 8.183 12 6 10.364l19.09-5.455z",
  mask: "url(#google_svg__h)"
}))));
export { SvgGoogle as ReactComponent };
export default __webpack_public_path__ + "static/media/google.630b1f7b.svg";